// extracted by mini-css-extract-plugin
module.exports = {"razaoSocialContainer":"style_razaoSocialContainer__MDEp0","razaoSocialText":"style_razaoSocialText__3Tejq","link_footer":"style_link_footer__26Hm5"};